import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

export const Loader = ({ size = 30 }) => {
  return <CircularProgress size={size} />;
};
